import { useTLang } from 'intl/intl';
import { OrderId } from 'shared/domain';
import { storeAuditService } from '../../infra';

export function useStoreAuditAlert({ orderId }: Props) {
  const _orderAudit = storeAuditService.getOrderAudit(orderId);
  const successText = useTLang({
    id: 'orderDetailDialogBagsDrinksBox.mandatoryInput.defectProductsCheckeded',
  });
  const errorText = useTLang({
    id:
      'orderDetailDialogBagsDrinksBox.mandatoryInput.defectProductsNotCheckeded',
  });
  const title = useTLang({
    id: 'orderDetailDialogBagsDrinksBox.detailTitle',
  });

  return {
    isAllChecked: _orderAudit?.isAllChecked,
    successText,
    errorText,
    title,
  };
}

type Props = {
  orderId: OrderId;
};
